module.exports = __webpack_public_path__ + "img/whiteAva.01459fca.svg";